import { RegistrationBewareFormVM } from 'mutation/view-models/registration-beware';
import { RegisterBeware } from 'shell/models/register-beware';

export const transformerRequestRegisterBewareData = (
  values: RegistrationBewareFormVM
): RegisterBeware => {
  let datiSoggetto = undefined;

  let inserimentoDiffidato = undefined;

  if (values.person?.generality?.codiceFiscale) {
    // soggetto esistente

    datiSoggetto = {
      generalita: values.person?.generality,
      residenza: values.person?.residence,
      cittadinanza: values.person?.citizenship,
    };
  }

  if (values.registrationNewPerson?.fiscalCode) {
    // nuovo soggetto

    inserimentoDiffidato = {
      codiceFiscale: values.registrationNewPerson?.fiscalCode || undefined,
      cognome: values.registrationNewPerson?.surname || undefined,
      nome: values.registrationNewPerson?.name || undefined,
      sesso: values.registrationNewPerson?.gender || undefined,
      dataNascita: values.registrationNewPerson?.birthDate
        ? values.registrationNewPerson?.birthDate?.toFormat('yyyy-MM-dd')
        : undefined,
      comuneNascita: values.registrationNewPerson?.isForeignBirth
        ? undefined
        : {
            denominazione:
              values.registrationNewPerson?.italianBirth?.municipality?.description || undefined,
            codiceSiglaProvincia:
              values.registrationNewPerson?.italianBirth?.municipality?.province || undefined,
          },
      comuneEsteroNascita: values.registrationNewPerson?.isForeignBirth
        ? {
            key: {
              codice: values.registrationNewPerson?.foreignBirth?.foreignMunicipality?.id
                ? Number.parseInt(
                    values.registrationNewPerson?.foreignBirth?.foreignMunicipality?.id,
                    10
                  )
                : undefined,
            },
            provincia:
              values.registrationNewPerson?.foreignBirth?.foreignMunicipality?.province ||
              undefined,
          }
        : undefined,
      comuneDomicilio: values.registrationNewPerson?.isForeignDomicile
        ? undefined
        : {
            denominazione:
              values.registrationNewPerson?.italianDomicile?.municipality?.description || undefined,
            codiceSiglaProvincia:
              values.registrationNewPerson?.italianDomicile?.municipality?.province || undefined,
          },
      comuneEsteroDomicilio: values.registrationNewPerson?.isForeignDomicile
        ? {
            key: {
              codice: values.registrationNewPerson?.foreignDomicile?.foreignMunicipality?.id
                ? Number.parseInt(
                    values.registrationNewPerson?.foreignDomicile?.foreignMunicipality?.id,
                    10
                  )
                : undefined,
            },
            provincia:
              values.registrationNewPerson?.foreignDomicile?.foreignMunicipality?.province ||
              undefined,
          }
        : undefined,
      indirizzo: values.registrationNewPerson?.address || undefined,
    };
  }

  return {
    datiSoggetto,
    diffida: {
      tipoDiffida: values.subjectAttributes?.formBeware?.typology || undefined,
      dalGiorno: values.subjectAttributes?.formBeware?.dateForm
        ? values.subjectAttributes?.formBeware?.dateForm?.toFormat('yyyy-MM-dd')
        : undefined,
      comune: values.subjectAttributes?.formBeware?.isForeign
        ? undefined
        : {
            denominazione:
              values.subjectAttributes?.formBeware?.municipalityItalian?.description || undefined,
            codiceIstat: values.subjectAttributes?.formBeware?.municipalityItalian?.id || undefined,

            codiceSiglaProvincia:
              values.subjectAttributes?.formBeware?.municipalityItalian?.province || undefined,
          },
      comuneEstero: values.subjectAttributes?.formBeware?.isForeign
        ? {
            key: {
              codice: values.subjectAttributes?.formBeware?.municipalityForeign?.id
                ? Number.parseInt(values.subjectAttributes?.formBeware?.municipalityForeign?.id, 10)
                : undefined,
            },
            provincia:
              values.subjectAttributes?.formBeware?.municipalityForeign?.province || undefined,
          }
        : undefined,
      perAnni: values.subjectAttributes?.formBeware?.year
        ? Number.parseInt(values.subjectAttributes?.formBeware?.year, 10)
        : undefined,
      note: values.subjectAttributes?.formBeware?.note || undefined,
    },
    inserimentoDiffidato,
  };
};
